module.exports = __webpack_public_path__ + "fonts/Rubik-LightItalic.de021b8d.ttf";